import parse from 'url-parse';

export const getUserPath = (username: string, path: string): string => {
  return `/${username}/${path}`;
};

export const getViewAsVisitorUrl = (url: string): string => {
  const parsed = parse(url, {}, true);
  const query = { ...parsed.query, visitor: 1 };
  parsed.set('query', query);
  return parsed.href;
};
